import React, { useEffect, useState } from "react";

import { getContactLink, goTo, trackMixpanel, useGeneralContext, useLocation, useNavContext, useNavigate, useUserContext } from "utils";

import { Alert, Anchor, Badge, Col, ErrorBoundary, Icon, Layout, Link, Row, SelectLanguage, Svg } from "components";

import { NavDrawer } from "pages/app/_app/components/NavDrawer";

export const HeaderMobile = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { referralBanner } = useGeneralContext();
  const { user } = useUserContext();
  const { showHeader } = useNavContext();

  const [showNavDrawer, setShowNavDrawer] = useState(false);

  const [notificationCount, setNotificationCount] = useState(0);

  const ReferralBanner = ({ text }) => (
    <Alert data-testid="alert-banner" className="alert-banner" description={text} icon="" type="green" closable={true} onClick={() => {}} showArrow />
  );

  useEffect(() => {
    if (user && notificationCount < user.notifications) {
      setNotificationCount(user.notifications);
    }
  }, [notificationCount, user]);

  useEffect(() => {
    setShowNavDrawer(false);
  }, [location.pathname]); // eslint-disable-line

  const { Header } = Layout;

  const HeaderCustom = () => (
    <section className={`container ${location.pathname.includes("/confirm-account") ? "tiny" : "tiniest"}`}>
      <Header className="margin-top-200 margin-bottom-200 logged-out">
        <div className={"flex-center-space-between"}>
          <Link to="/" mixpanelText="klim-logo">
            <Svg svgName="logos/klim_logo_text_black" className="logo" />
          </Link>
          <ErrorBoundary>
            <SelectLanguage placement="bottomRight" />
          </ErrorBoundary>
        </div>
      </Header>
    </section>
  );

  if (!user) {
    return (
      <>
        {referralBanner && <ReferralBanner text={referralBanner.text} />}
        {showHeader && <HeaderCustom />}
      </>
    );
  }

  const getClassName = () => {
    if (location.pathname.includes("notifications") && !location.pathname.includes("manage-notifications")) return "head container notifications";
    if (location.pathname === "/search") return "head container search-page";
    if (location.pathname.includes("crop-explorer")) return "head container-full-width";
    return "head container";
  };

  if (!showHeader) {
    return null;
  }

  return (
    <>
      <section className={getClassName()}>
        <Row justify="space-around" align="middle">
          <Col sm={8} md={8} style={{ display: "flex", alignItems: "center" }}>
            <Link to="/dashboard" mixpanelText="klim-logo">
              <Svg svgName="logos/klim_logo_text_black" className="logo" />
            </Link>
          </Col>
          <Col sm={16} md={16} className="right">
            <Icon
              iconName="tabler/search"
              size="m"
              className="icon search"
              onClick={() => {
                navigate("/search");
                trackMixpanel("ClickLink", {
                  linkText: "search",
                  link: "/search",
                });
              }}
            />
            <Anchor
              onClick={() => {
                navigate("/notifications");
                trackMixpanel("ClickLink", {
                  linkText: "notifications",
                  link: "/notifications",
                });
              }}
            >
              <Badge type="number" count={user.notifications ? user.notifications : 0} offset={[-10, 4]}>
                <Icon iconName="tabler/bell" size="m" className="icon bell" />
              </Badge>
            </Anchor>
            <Icon
              dataTestId="nav-bar-contact-center-icon"
              onClick={(e) => goTo(e, null, getContactLink(), true)}
              iconName="tabler/help"
              size="m"
              className="icon"
            />
            <Icon dataTestId="open-nav-bar-drawer-icon" iconName="tabler/menu" className="icon" size="m" onClick={() => setShowNavDrawer(true)} />
          </Col>
        </Row>
      </section>
      <NavDrawer visible={showNavDrawer} onClose={() => setShowNavDrawer(false)} />
    </>
  );
};

export default HeaderMobile;
